import React from 'react';
import classnames from 'classnames';
import { ZoneType } from '../../../../../types/layout';
import { ModuleType } from '../../../../../types/modules';

import s from './WidgetMiniature.scss';

export interface Props {
  moduleName: ModuleType;
  zone: ZoneType;
  isLocked?: boolean;
  isNew?: boolean;
}

export const moduleClassnamesByName = {
  [ModuleType.ABOUT]: 'about',
  [ModuleType.WATCHERS]: 'watchers',
  [ModuleType.WATCHING]: 'watching',
  [ModuleType.GROUPS_MEMBER]: 'groups-member',
  [ModuleType.GROUPS_ADMIN]: 'groups-admin',
  [ModuleType.DONATIONS]: 'donations',
  [ModuleType.DEVIOUSNESS]: 'deviousness',
  [ModuleType.FEED]: 'feed',
  [ModuleType.MY_COMMENTS]: 'my-comments',
  [ModuleType.COMMENTS]: 'profile-comments',
  [ModuleType.BADGES_ACTIVITY]: 'my-badges',
  [ModuleType.STATS]: 'stats',
  [ModuleType.FEATURED_DEVIATION]: 'featured-deviation',
  [ModuleType.FEATURED_POST]: 'featured-post',
  [ModuleType.CUSTOM]: 'custombox',
  [ModuleType.MEGABOX]: 'megabox',
  [ModuleType.TIERS]: 'tiers',
  [ModuleType.BADGES_SPOTLIGHT]: 'my-badges',
  [ModuleType.LLAMA_FARM]: 'llamafarm',
};

const WidgetMiniature: React.FC<Props> = ({
  moduleName,
  zone,
  isLocked,
  isNew,
}) => {
  let className;
  if (moduleName === ModuleType.EXHIBITIONIST) {
    if (zone === ZoneType.TOP_BAR) {
      className = 'exhibitionist-slider';
    } else {
      className = 'exhibitionist-grid';
    }
  } else if (moduleClassnamesByName.hasOwnProperty(moduleName)) {
    className = moduleClassnamesByName[moduleName];
  }

  if (!className) {
    return null;
  }

  let miniatureType;
  if (isLocked) {
    miniatureType = 'locked';
  } else if (isNew) {
    miniatureType = 'new';
  }

  return (
    <div
      className={classnames(
        s['root'], 
        s[miniatureType],
        s[className]
      )}
    >
      <div className={s['miniature']} />
    </div>
  );
}
WidgetMiniature.displayName = 'WidgetMiniature';
export default WidgetMiniature;
